import { PawPrint } from "lucide-react";

const ITEMS = ["SALUTE", "SITTER DI FIDUCIA", "COMMUNITY", "FUFFYFAM", "DOG-FRIENDLY"];

const Row = ({ hidden }) => (
  <div className="flex items-center shrink-0" aria-hidden={hidden}>
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-6xl lg:text-7xl text-[#1A1A1A] px-6 sm:px-10 whitespace-nowrap">
          {item}
        </span>
        <PawPrint className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF6B35] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = ({ reverse = false }) => (
  <section
    data-testid={reverse ? "marquee-bottom" : "marquee-top"}
    className="py-8 sm:py-10 border-y border-[#1A1A1A]/10 overflow-hidden select-none"
  >
    <div className={`marquee-track ${reverse ? "reverse" : ""}`}>
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </section>
);
